import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import fetchLotsUsingSource from '../api/fetchLotsUsingSource';

export default function useLotsUsingSource(lotId) {
  return useQuery({
    queryKey: ['lotsUsingSource', lotId],
    queryFn: () => fetchLotsUsingSource(lotId),
    enabled: !!lotId,
  });
}

/**
 * Parameterized invalidator: a mutation that consumes a lot (assembly) adds
 * a row to that lot's "used by" genealogy — drop the cached query so any
 * open source-lot page refetches.
 */
export function useInvalidateLotsUsingSource() {
  const queryClient = useQueryClient();
  return useCallback(
    (lotId) => queryClient.invalidateQueries({ queryKey: ['lotsUsingSource', lotId] }),
    [queryClient],
  );
}
